/**
 * The one active sort of `<o2d-table>` (v1 supports a single active sort only).
 *
 * House rule "eine Datei pro Type": `O2dTableSort` folds together with its event
 * constant and detail type here, because the barrel `src/index.ts` must NOT be the
 * declaration site (popover-list pattern — event constants live in a real source
 * file, then get re-exported by the barrel).
 */
export type O2dTableSort = {
    /** `id` of the `O2dTableColumn` the rows are ordered by. */
    columnId: string;
    /** Sort direction — asc↔desc only in v1 (no third "unsorted" state). */
    direction: 'asc' | 'desc';
};

/** Event name constant for the sort-changed event (declared here, re-exported by the barrel). */
export const O2D_TABLE_SORT_CHANGED = 'o2d-table.sort-changed' as const;

/**
 * Detail payload for the `o2d-table.sort-changed` event.
 *
 * Equal to `O2dTableSort`; `AbstractO2dElement.fireEvent` injects `timestamp` on
 * dispatch, so consumers additionally receive a `timestamp` field at runtime.
 */
export type O2dTableSortChangedDetail = O2dTableSort;
